import { graphql, HeadFC, PageProps } from "gatsby";
import * as React from "react";

import { PageHeaderSubtitle, PageHeaderTitle } from "components/PageHeader";
import { PageSection } from "components/PageSection";
import { FeaturedPost } from "components/Post/FeaturedPost";
import { PostsGrid } from "components/Post/PostsGrid";
import { getPageMetaFromUrl } from "helpers/meta";
import Layout from "templates/layout";

const PressReleasePage = ({
  data,
  location,
}: PageProps<Queries.PressReleasesQuery>) => {
  const { nodes: posts } = data.posts;

  const orderedPosts = posts.sort((a, b) => {
    const aDate = new Date(a.date);
    const bDate = new Date(b.date);
    return bDate - aDate;
  });

  const featuredPost = orderedPosts[0];

  return (
    <Layout title="Press Releases" pathname={location.pathname}>
      <PageSection variant="full">
        <PageHeaderTitle>
          Exponential Markets
          <br />
          in the news
        </PageHeaderTitle>
        {orderedPosts.length === 0 && (
          <PageHeaderSubtitle>
            There are no press releases yet.
          </PageHeaderSubtitle>
        )}
      </PageSection>
      {orderedPosts.length > 0 && featuredPost && (
        <>
          <FeaturedPost post={featuredPost} />
          <PostsGrid posts={orderedPosts.slice(1)} />
        </>
      )}
    </Layout>
  );
};

export default PressReleasePage;

export const Head: HeadFC = () =>
  getPageMetaFromUrl("/in-the-press/press-releases");

export const query = graphql`
  query PressReleases {
    posts: allSanityPost(
      filter: { category: { slug: { current: { eq: "press-release" } } } }
    ) {
      nodes {
        title
        subtitle
        date
        image {
          asset {
            gatsbyImageData(layout: CONSTRAINED, formats: [AUTO])
          }
        }
        slug {
          current
        }
        isExternal
        externalUrl
        category {
          name
          slug {
            current
          }
        }
        subcategory
        author
        content {
          _rawChildren
        }
      }
    }
  }
`;
